var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2499.6 2500",
    viewBox: "0 0 2499.6 2500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1187.9 1187.9h-1187.9v-1187.9h1187.9z",
    fill: "#f1511b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2499.6 1187.9h-1188v-1187.9h1187.9v1187.9z",
    fill: "#80cc28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1187.9 2500h-1187.9v-1187.9h1187.9z",
    fill: "#00adef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2499.6 2500h-1188v-1187.9h1187.9v1187.9z",
    fill: "#fbbc09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.e116a418f9c5f551889532b8c5095213.svg";
export { ForwardRef as ReactComponent };